import { makeRequest } from "./api";

export const FetchHouseRules = async () => {
  return makeRequest("/api/admin/propertyRules/fetch");
};

export const CreateHouseRules = async (itemName, status) => {
  return makeRequest("/api/admin/propertyRules/create", {
    method: "POST",
    data: {
      itemName,
      status,
    },
  });
};

export const UpdateHouseRules = async (propertyRuleId, itemName, status) => {
  return makeRequest("/api/admin/propertyRules/update", {
    method: "PUT",
    data: {
      propertyRuleId,
      itemName,
      status,
    },
  });
};

export const DeleteHouseRules = async (propertyRuleId) => {
  return makeRequest(`/api/admin/propertyRules/remove/${propertyRuleId}`, {
    method: "DELETE",
  });
};
